import React from 'react';

export const LoyaltyIcon = () => {
  return (
    <svg viewBox="0 0 300 300" className="w-full h-auto">
      <ellipse cx="150" cy="260" rx="140" ry="20" fill="#d1f4f0" opacity="0.5"></ellipse>
      <ellipse cx="150" cy="255" rx="120" ry="15" fill="#b8ede7" opacity="0.6"></ellipse>
      <ellipse cx="150" cy="250" rx="100" ry="10" fill="#9fe6dd" opacity="0.7"></ellipse>
      <rect x="90" y="120" width="80" height="100" rx="6" fill="#e5e7eb"></rect>
      <rect x="95" y="125" width="70" height="90" rx="5" fill="#f3f4f6"></rect>
      <path d="M 110 145 L 120 135 L 130 145 L 140 135 L 150 145" stroke="#fbbf24" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"></path>
      <polygon points="120,155 110,165 120,175 130,165" fill="#fbbf24"></polygon>
      <line x1="100" y1="185" x2="160" y2="185" stroke="#d1d5db" strokeWidth="2"></line>
      <line x1="100" y1="195" x2="155" y2="195" stroke="#d1d5db" strokeWidth="2"></line>
      <line x1="100" y1="205" x2="145" y2="205" stroke="#d1d5db" strokeWidth="2"></line>
      <rect x="140" y="140" width="70" height="80" rx="6" fill="#f59e0b"></rect>
      <rect x="145" y="145" width="60" height="70" rx="5" fill="#fbbf24"></rect>
      <path d="M 160 160 L 175 145 L 190 160 L 175 175 Z" fill="#ffffff" opacity="0.3"></path>
      <rect x="160" y="175" width="30" height="30" rx="3" fill="#ffffff" opacity="0.4"></rect>
      <path d="M 165 185 L 175 195 L 185 180" stroke="#f59e0b" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"></path>
      <circle cx="100" cy="200" r="30" fill="#fbbf24"></circle>
      <circle cx="105" cy="195" r="30" fill="#f59e0b"></circle>
      <circle cx="110" cy="190" r="30" fill="#f59e0b" opacity="0.9"></circle>
      <path d="M 95 190 L 110 190 L 110 175 M 110 190 L 125 190 M 110 190 L 110 205" stroke="#ffffff" strokeWidth="5" fill="none" strokeLinecap="round"></path>
      <circle cx="95" cy="210" r="25" fill="#fbbf24" opacity="0.7"></circle>
      <circle cx="100" cy="205" r="25" fill="#f59e0b" opacity="0.6"></circle>
      <circle cx="105" cy="200" r="25" fill="#f59e0b" opacity="0.5"></circle>
      <path d="M 90 200 L 105 200 L 105 185 M 105 200 L 120 200 M 105 200 L 105 215" stroke="#ffffff" strokeWidth="4" fill="none" strokeLinecap="round" opacity="0.5"></path>
      <rect x="170" y="100" width="60" height="50" rx="6" fill="#f59e0b"></rect>
      <rect x="175" y="105" width="50" height="40" rx="5" fill="#fbbf24"></rect>
      <rect x="185" y="115" width="30" height="20" rx="3" fill="#ffffff" opacity="0.5"></rect>
      <path d="M 190 120 L 200 130 L 210 118" stroke="#f59e0b" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"></path>
      <path d="M 180 135 L 220 135" stroke="#ffffff" strokeWidth="2" opacity="0.6"></path>
      <path d="M 180 140 L 215 140" stroke="#ffffff" strokeWidth="2" opacity="0.6"></path>
    </svg>
  );
};
